.wrap {
  position: absolute;
  inset: 0;
  z-index: 8;
  background:
    radial-gradient(ellipse at center, rgba(20, 10, 12, 0.55) 0%, rgba(5, 6, 7, 0.88) 70%);
  backdrop-filter: blur(6px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 22px;
  padding: 24px;
  animation: fadeIn 0.25s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.replay {
  border: 0;
  background: linear-gradient(135deg, #e11d2e, #ff4d5a);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  padding: 12px 26px;
  border-radius: 999px;
  cursor: pointer;
  box-shadow: 0 8px 24px rgba(225, 29, 46, 0.4);
  transition: transform 0.15s ease;
}

.replay:hover {
  transform: scale(1.04);
}

.grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  max-width: 720px;
}

.card {
  width: 160px;
  text-decoration: none;
  color: #fff;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  transition: background 0.15s ease, transform 0.15s ease;
}

.card:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

.card img {
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
  display: block;
}

.card span {
  opacity: 0.7;
  padding: 8px 8px 0;
}

.card strong {
  padding: 4px 8px 10px;
  font-weight: 650;
}
